import React, { useEffect, useState } from 'react'
import Tabs from 'antd/lib/tabs'
import Tooltip from 'antd/lib/tooltip'
import Account from './Account'
import { LocationSettingProps } from '../Settings'
import { useQuery } from '@apollo/client'
import { QUERY_LOCATION_STRIPE_ACCOUNT_SESSION } from '../LocationQueries'
import { useSession } from '@slerp/accounts'
import Invoices from 'components/Settings/AccountsAndBilling/Invoices'
import CreditNotes from 'components/Settings/AccountsAndBilling/CreditNotes'
import { useLocation } from 'react-router-dom'
import { urlChanger } from 'components/Settings/AccountsAndBilling/utils'
import { InvoiceKind } from 'components/Settings/AccountsAndBilling/types'

const { TabPane } = Tabs

const AccountsAndBilling = ({ store }: LocationSettingProps) => {
  const { merchant } = useSession()
  const location = useLocation()
  const [activeTab, setActiveTab] = useState<string>('account')

  useQuery(QUERY_LOCATION_STRIPE_ACCOUNT_SESSION, {
    variables: { storeId: store.id },
    onCompleted: (data) => {
      const { clientSecret, publicKey } =
        data?.getMerchantStripeAccountSession || {}

      if (clientSecret && publicKey) {
        //@ts-ignore
        window.StripeConnect = window.StripeConnect || {}
        ;(async () => {
          //@ts-ignore
          window.StripeConnect.onLoad = () => {
            //@ts-ignore
            window.StripeConnect.init({
              publishableKey: publicKey,
              clientSecret: clientSecret,
              appearance: {
                colors: {
                  primary: '#625afa',
                  textLink: '#625afa'
                }
              },
              uiConfig: {
                overlay: 'dialog'
              }
            })
          }
        })()
      }
    }
  })

  useEffect(() => {
    const currentPath = location.pathname

    if (currentPath.includes('/invoices')) {
      setActiveTab('invoices')
    }

    if (currentPath.includes('/credit-notes')) {
      setActiveTab('credit-notes')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const tabChangeHandler = (key: string) => {
    urlChanger(key)
    setActiveTab(key)
  }

  return (
    <Tabs activeKey={activeTab} onChange={tabChangeHandler} className='_mb-8'>
      <TabPane
        key='account'
        tab={
          <Tooltip title='Account'>
            <span>Account</span>
          </Tooltip>
        }
      >
        <Account store={store} />
      </TabPane>

      {merchant?.stripe_account_type === 'slerp_pay' && (
        <>
          <TabPane
            key='payment'
            tab={
              <Tooltip title='Payment'>
                <span>Payment</span>
              </Tooltip>
            }
          >
            <div className='container'>
              {/* @ts-ignore */}
              <stripe-connect-payments />
            </div>
          </TabPane>
          <TabPane
            key='payout'
            tab={
              <Tooltip title='Payout'>
                <span>Payout</span>
              </Tooltip>
            }
          >
            <div className='container'>
              {/* @ts-ignore */}
              <stripe-connect-payouts />
            </div>
          </TabPane>
          <TabPane
            key='invoices'
            tab={
              <Tooltip title='Invoices'>
                <span data-testid='invoices-tab-pane'>Invoices</span>
              </Tooltip>
            }
          >
            <Invoices store={store} kind={InvoiceKind.invoice} />
          </TabPane>
          <TabPane
            key='receipts'
            tab={
              <Tooltip title='Receipts'>
                <span data-testid='receipts-tab-pane'>Receipts</span>
              </Tooltip>
            }
          >
            <Invoices store={store} kind={InvoiceKind.receipt} />
          </TabPane>
          <TabPane
            key='credit-notes'
            tab={
              <Tooltip title='Credit Notes'>
                <span data-testid='invoices-tab-pane'>Credit Notes</span>
              </Tooltip>
            }
          >
            <CreditNotes store={store} />
          </TabPane>
        </>
      )}
    </Tabs>
  )
}

export default AccountsAndBilling
